import { Employee } from '@data-terminal/shared-models/employee';
import { InjectionToken } from '@angular/core';
import { RxState } from '@rx-angular/state';

export enum GlobalStateSelectors {
    OTHER_ACTIVITIES = 'otherActivities',
    All_EMPLOYEES = 'allEmployees',
}

export interface GlobalState {
    [GlobalStateSelectors.All_EMPLOYEES]: Employee[];
}

export const GLOBAL_RX_STATE = new InjectionToken<RxState<GlobalState>>('GLOBAL_RX_STATE');
